import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { TrendingUp, AlertCircle } from "lucide-react";

/**
 * Tiny per-alias analytics strip shown in each alias row.
 * Pulls from /api/aliases/{id}/stats and displays received/issues + delivery rate.
 */
export default function AliasStats({ aliasId, compact = true }) {
  const [days, setDays] = useState(30);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!aliasId) return;
    setLoading(true);
    api.get(`/aliases/${aliasId}/stats`, { params: { days } })
      .then((r) => setStats(r.data))
      .catch(() => setStats({ ok: false }))
      .finally(() => setLoading(false));
  }, [aliasId, days]);

  if (loading && !stats) return null;
  if (!stats?.ok) return null;

  const c = stats.counts || {};
  const received = c.accepted || 0;
  const issues = (c.failed || 0) + (c.rejected || 0) + (c.complained || 0);

  return (
    <div data-testid={`alias-stats-${aliasId}`} className="flex items-center gap-3 text-[11px]">
      <div className="flex rounded-md border border-[#E2E8F0] overflow-hidden">
        {[7, 30, 90].map((d) => (
          <button
            key={d}
            onClick={() => setDays(d)}
            data-testid={`alias-stats-${aliasId}-${d}d`}
            className={`px-2 py-0.5 font-semibold transition-colors ${
              days === d
                ? "bg-[#0F172A] text-white"
                : "bg-white text-slate-400 hover:bg-slate-50"
            }`}
          >
            {d}d
          </button>
        ))}
      </div>
      <div className="flex items-center gap-1 text-emerald-700">
        <TrendingUp className="h-3 w-3" />
        <span className="font-bold">{received}</span>
        <span className="text-slate-400">{compact ? "in" : "received"}</span>
      </div>
      {issues > 0 && (
        <div className="flex items-center gap-1 text-amber-600">
          <AlertCircle className="h-3 w-3" />
          <span className="font-bold">{issues}</span>
          <span className="text-slate-400">issue{issues === 1 ? "" : "s"}</span>
        </div>
      )}
    </div>
  );
}
